import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Consultation } from "../../../services/profile/profileModel";
import { User } from "../../../services/user/userModel";
import { userService } from "../../../services/user/userService";
import { cx } from "../../../react-helpers/css";
import { loggerBuilder } from "../../../services/logger";
import { toastsWithIntl } from "../../../services/toastService";

const logger = loggerBuilder("premium-stats");

const DAY_MS = 24 * 3600 * 1000;
// Blurred teaser values shown to non-premium candidates
const DUMMY_TOTAL_VIEWS = 47;
const DUMMY_CONSULTATIONS: Consultation[] = [
  {
    consultationDate: new Date(Date.now() - 2 * DAY_MS).toISOString(),
    organizationName: "VEOLIA",
  },
  {
    consultationDate: new Date(Date.now() - 4 * DAY_MS).toISOString(),
    organizationName: "SNCF",
  },
  {
    consultationDate: new Date(Date.now() - 9 * DAY_MS).toISOString(),
    organizationName: "CARREFOUR",
  },
];

const PremiumStatsSection = ({
  loggedUser,
  isPremium,
  consultations,
}: {
  loggedUser: User;
  isPremium: boolean;
  consultations: Consultation[];
}) => {
  const { t } = useTranslation(["candidate"]);
  const { getPremiumUserLink } = userService();
  const { toastError } = toastsWithIntl(["common"]);
  const [loadingPremium, setLoadingPremium] = useState(false);

  const history = isPremium
    ? consultations.filter((consultation) => !!consultation.organizationName)
    : DUMMY_CONSULTATIONS;
  const totalViews = isPremium ? consultations.length : DUMMY_TOTAL_VIEWS;

  return (
    <div className="lblock premium-stats">
      <h2 className="premium-stats_title">
        {t("candidate:profile.premium-stats.TITLE")}
      </h2>
      <p className="cblock">
        {t("candidate:profile.premium-stats.TOTAL_VIEWS")}{" "}
        <span className={cx([!isPremium && "--blurred"])}>{totalViews}</span>
      </p>
      {history.length > 0 && (
        <>
          <p className="cblock">
            {t("candidate:profile.premium-stats.HISTORY")}
          </p>
          <ul className="cblock premium-stats_history">
            {history.map((consultation, index) => (
              <li key={index} className={cx([!isPremium && "--blurred"])}>
                {t("candidate:profile.premium-stats.HISTORY_ROW", {
                  date: new Date(consultation.consultationDate),
                  organization: consultation.organizationName,
                })}
              </li>
            ))}
          </ul>
        </>
      )}
      {!isPremium && (
        <div className="lblock">
          <button
            className="btn--1"
            disabled={loadingPremium}
            onClick={() => {
              const handlePremiumClick = async () => {
                try {
                  setLoadingPremium(true);
                  const result = await getPremiumUserLink(loggedUser.id);
                  if (result?.url) window.location.href = result.url;
                } catch (err) {
                  logger.error(
                    "Erreur lors de la récupération du lien premium",
                    err,
                  );
                  toastError("common:error.header.PREMIUM_LINK_ERROR");
                  return;
                } finally {
                  setLoadingPremium(false);
                }
              };

              void handlePremiumClick();
            }}
          >
            {loadingPremium ? "..." : t("candidate:profile.premium-stats.CTA")}
          </button>
        </div>
      )}
    </div>
  );
};

export default PremiumStatsSection;
